export let ApplicationFunctionDesign = {
    path: '/application-function-design',
    name: 'application-function-design',
    meta: {
        roleCode: '005',
    },
    component: () =>
        import(
            /* webpackChunkName: "application-function-design" */ '@/views/back-stage/application-function-design/application-function-design.vue'
        ),
};
